import difference from 'lodash.difference';

const itemsAddedCount = (initialItems, updatedItems) =>
  difference(
    updatedItems.map((a) => a.id),
    initialItems.map((a) => a.id)
  ).length;

export default itemsAddedCount;
